import { render, staticRenderFns } from "./WordpressSuite.vue?vue&type=template&id=8096ce06&scoped=true&"
import script from "./WordpressSuite.vue?vue&type=script&lang=ts&"
export * from "./WordpressSuite.vue?vue&type=script&lang=ts&"
import style0 from "./WordpressSuite.vue?vue&type=style&index=0&id=8096ce06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8096ce06",
  null
  
)

export default component.exports